"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contactRepository = void 0;
const utils_1 = require("@hc-frontend/utils");
const contactRepository = {
    getContact() {
        return (0, utils_1.loadObject)("hc/contact" /* Contact */);
    },
    saveContact(contact) {
        (0, utils_1.saveObject)("hc/contact" /* Contact */, contact);
    },
};
exports.contactRepository = contactRepository;
//# sourceMappingURL=contact-repository.js.map